import { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import mapLoyaltyAccountActivity from 'api/mappers/loyalty/mapLoyaltyAccountActivity'
import requestUtils from 'api/requestUtils'
import qs from 'qs'

type Response = paths['/api/lux-loyalty/account/activities']['get']['responses']['200']['content']['application/json']

async function requestLoyaltyAccountActivity(customerId: string, startDate: string, endDate: string) {
  const params = qs.stringify({
    customerId,
    fromDate: startDate,
    toDate: endDate,
  })
  const response = await requestUtils.get<Response>(`/api/lux-loyalty/account/activities?${params}`, {
    credentials: 'include',
    excludeBrand: true,
  })

  return response.result.activities.map(mapLoyaltyAccountActivity)
}

export default requestLoyaltyAccountActivity
